export default __webpack_public_path__ + "static/media/exclamation.4ac95193.svg";